import { Spin } from 'antd';

const ScreenFreezLoader = ({ loading, text = "Loading..." }) => {
  if (!loading) return null;

  return (
    <div className={'screenfreezloader'}>
      <Spin size="large" tip={text} />
    </div>
  );
};

export default ScreenFreezLoader;
